import { useEffect } from "react";

export default function SiteMeta({ title, description }) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;

    let meta = document.querySelector('meta[name="description"]');
    const created = !meta;
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    const prevDescription = meta.getAttribute("content");
    if (description) meta.setAttribute("content", description);

    return () => {
      document.title = prevTitle;
      if (created) meta.remove();
      else if (prevDescription != null) meta.setAttribute("content", prevDescription);
    };
  }, [title, description]);

  return null;
}
